import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

interface BottomBoxProps {
  pages: readonly string[];
  labels: Record<string, string>;
  onLinkTap: (index: number) => void;
}

export const BottomBox: React.FC<BottomBoxProps> = ({
  pages,
  labels,
  onLinkTap,
}) => {
  return (
    <Box
      data-testid="bottom-navbar"
      sx={{
        width: "100%",
        textAlign: "center",
        py: 2,
        backgroundColor: "transparent",
      }}
    >
      {/* Navigation Links */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 3,
        }}
      >
        {pages.map((page, index) => (
          <Typography
            key={page}
            onClick={() => onLinkTap(index)}
            sx={{
              cursor: "pointer",
              fontSize: { xs: 12, md: 16 },
              fontWeight: "bold",
              letterSpacing: 1.5,
              color: "rgb(55, 54, 54)",
              transition: "color 0.3s ease-in-out",
              "&:hover": { color: "primary.main" },
            }}
          >
            {labels[page]}
          </Typography>
        ))}
      </Box>

      {/* Spacer */}
      <Box sx={{ height: 8 }} />

      {/* Footer Text */}
      <Container sx={{ py: 2 }}>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: "bold",
            letterSpacing: 1.5,
            color: "rgb(55, 54, 54)",
          }}
        >
          ©2025 Khanh Mai, LLC
        </Typography>
      </Container>
    </Box>
  );
};
